import { Stack, Typography } from "@mui/material";

interface ICardRow {
  title: string;
  titleContext: any;
}

export function CardRow({ title, titleContext }: ICardRow) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "flex-start", sm: "start" }}
      spacing={{ xs: 0.35, sm: 1 }}
      sx={{
        py: { xs: 1.25, sm: 2.5, md: 3 },
        px: { xs: 1.5, sm: 2.5, md: 3 },
        pl: { xs: 1.5, sm: 2.5, md: 5 },
        pr: { xs: 1.5, sm: 2.5, md: 3 },
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          width: { xs: "100%", sm: "20%" },
          textAlign: "left",
          wordBreak: "break-word",
          fontWeight: 500,
          fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        color="text.primary"
        sx={{
          width: { xs: "100%", sm: "80%" },
          textAlign: "left",
          fontWeight: 600,
          wordBreak: "break-word",
          fontSize: { xs: "0.875rem", sm: "0.9375rem", md: "1rem" },
        }}
      >
        {titleContext}
      </Typography>
    </Stack>
  );
}
